import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {MenuService} from '../menu.service';
import {Location} from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class MenuServiceGuard implements CanActivate {

    lang: string;

    constructor(
        private menuService: MenuService,
        private location: Location,
        private route: ActivatedRoute) {
    }

    canActivate(activatedRouteSnapshots: ActivatedRouteSnapshot,
                routerStateSnapshot: RouterStateSnapshot): boolean {

        this.lang = activatedRouteSnapshots.data.lang;
        // console.log('routerStateSnapshot: ' + routerStateSnapshot.url + ', lang: ' + this.lang);
        this.menuService.changeLang(this.lang);
        return true;
        // const obs: Observable<any> [] = [];
        // obs.push(this.route.url, this.route.data);
        // return forkJoin(obs)
        //     .pipe(
        //         map( results => {
        //             const url = this.location.path().split('/');
        //             this.lang = results[1].lang;
        //             this.menuService.changeLang(this.lang);
        //             return true;
        //         })
        //     );
        // this.route.url.subscribe(() => {
        //
        //     console.log('siamo in: ' + url);
        // });
        // return this.route.data
        //     .pipe(
        //         map( data => {
        //             this.lang = data.lang;
        //             this.menuService.changeLang(this.lang);
        //             return true;
        //         })
        //     );
    }
}
